import { createAsyncReducer } from '../../standard-actions';
import {
    IIrMonthPassAddOnsDetailsAction,
    IIrMonthPassAddOnsDetailsSuccessAction,
    IIrMonthPassAddOnsDetailsErrorAction
} from '../actions/load-ir-month-pass-add-ons-details'
import { IServiceRequestsState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadIrMonthPassAddOnsDetailsAction
    = IIrMonthPassAddOnsDetailsAction
    | IIrMonthPassAddOnsDetailsSuccessAction
    | IIrMonthPassAddOnsDetailsErrorAction;

const init = (state: IServiceRequestsState, action: LoadIrMonthPassAddOnsDetailsAction) => ({
    ...state,
    irMonthPassAddOnsDetails: {
        ...initialState.irMonthPassAddOnsDetails,
        status: action.status
    }
});

const success = (state: IServiceRequestsState, action: LoadIrMonthPassAddOnsDetailsAction) => ({
    ...state,
    irMonthPassAddOnsDetails: {
        ...initialState.irMonthPassAddOnsDetails,
        status: action.status,
        data: (action as IIrMonthPassAddOnsDetailsSuccessAction).data
    }
});

const failure = (state: IServiceRequestsState, action: LoadIrMonthPassAddOnsDetailsAction) => ({
    ...state,
    irMonthPassAddOnsDetails: {
        ...initialState.irMonthPassAddOnsDetails,
        status: action.status,
        error: (action as IIrMonthPassAddOnsDetailsErrorAction).error
    }
});

export const loadIrMonthPassAddOnsDetailsReducer = createAsyncReducer(initialState, init, success, failure);
